"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.ColumnField = exports.HdrListItem = exports.RegHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const sharedStyles_1 = require("../sharedStyles");
exports.RegHeader = styled_components_1.default.div `
  margin-top: 0px;
  transition: height 1s ease;
`;
exports.HdrListItem = styled_components_1.default.div `
`;
exports.ColumnField = styled_components_1.default.div `
  display: inline-block;
  font-weight: 500;
`;
const styles = (theme) => (Object.assign(Object.assign({}, (0, sharedStyles_1.sharedStyles)(theme)), { regColumnsHeader: {
        display: 'flex',
        alignItems: 'stretch',
        fontWeight: 500,
        color: theme.palette.text.strong,
        paddingTop: 8,
        paddingBottom: 5,
        background: theme.palette.background.paper,
        paddingLeft: theme.mixins.register.rowInnerPadding,
        paddingRight: theme.mixins.register.rowInnerPadding,
        borderBottom: 'solid 1px',
        borderBottomColor: theme.palette.border.default,
        width: '100%',
        '&::-webkit-scrollbar-button': {
            display: 'none',
            color: theme.palette.background.subtle,
            opacity: 0,
        },
        overflowX: 'hidden',
    }, regIcon: {
        color: theme.palette.text.primary,
    }, nop: {
        display: 'none',
    }, regColumnsHeaderWrapper: {
        background: theme.mixins.register.headerBackground,
        paddingLeft: theme.mixins.register.rowInnerPadding,
        paddingRight: theme.mixins.register.rowInnerPadding,
    }, inserting: {
        borderLeft: `solid 2px ${theme.palette.text.strong}`,
        borderRadius: 0,
    }, reviewedIcon: {
        height: 20,
        width: 20,
        color: theme.palette.text.tertiary,
        cursor: 'pointer',
        '&.reviewed': {
            color: theme.palette.success.dark,
        },
        '&.notreviewed': {
            color: theme.palette.text.disabled,
        },
    }, balanceHeader: {
        paddingRight: 10,
    } }));
exports.styles = styles;
